import posthog from 'posthog-js';

// Shared primitives for the typed event helpers. Keep this in sync with the
// conventions used by `community-events.ts`.

export type Platform = 'web' | 'mobile';
export type Surface = 'fan' | 'creator';
export type UserType = 'creator' | 'fan' | 'moderator' | 'anonymous';

/**
 * Properties that every product event should try to carry so funnels can be
 * stitched together in PostHog. All optional — pass what the call site knows.
 */
export interface BaseEventProps {
  creator_id?: string;
  user_id?: string;
  user_type?: UserType;
  platform?: Platform;
  surface?: Surface;
  notification_source?: 'email';
  email_campaign_key?: string;
  email_delivery_id?: string;
  email_attribution_authority?: 'client_reported';
}

/**
 * Single choke-point for `posthog.capture`. Defaults `platform` to `web` and
 * stamps `timestamp` so individual helpers don't have to repeat it.
 */
export const send = (event: string, props: Record<string, any> = {}) => {
  posthog.capture(event, {
    ...props,
    platform: props.platform ?? 'web',
    timestamp: Date.now(),
  });
};
